import { useMemo } from "react";
import { endOfDay, startOfDay, subDays } from "date-fns/esm";

import { DATA_RANGE_DAYS } from "./constants";

const useDoraDateRange = () => {
  return useMemo(() => {
    const startTime = startOfDay(subDays(new Date(), DATA_RANGE_DAYS));
    const endTime = endOfDay(new Date());

    return {
      startTime,
      endTime,
    };
  }, []);
};

export default useDoraDateRange;
